import defaultApi from '@/utils/request';

export default {
  // 加載列表
  S47W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S47/S47W4001_Load',
      params,
    });
  },
  S47W4001_StandardLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S47/S47W4001_StandardLoad',
      params,
    });
  },
  S47W4001_PrescriptionLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S47/S47W4001_PrescriptionLoad',
      params,
    });
  },

  // ========================================================================================================
  // S47W4003 體適能常模查詢
  // 取得學年
  S47W4003_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S47/S47W4003_Get_YmsList',
      params,
    });
  },
  // 取得登入學生之體適能測驗項目
  S47W4003_Get_PhyExamList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S47/S47W4003_Get_PhyExamList',
      params,
    });
  },
  // 取資料
  S47W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S47/S47W4003_Load',
      params,
    });
  },

  // =================  S47W2001 ===========================================================
  S47W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S03/S47/S47W2001_Load',
      params,
    });
  },
  S47W2001_QueryCourse(params) {
    return defaultApi({
      method: 'get',
      url: 'S03/S47/S47W2001_QueryCourse',
      params,
    });
  },
  S47W2001_LoadInputData(params) {
    return defaultApi({
      method: 'get',
      url: 'S03/S47/S47W2001_LoadInputData',
      params,
    });
  },
  S47W2001_SaveInputData(data) {
    return defaultApi({
      method: 'post',
      url: 'S03/S47/S47W2001_SaveInputData',
      data,
    });
  },
  S47W2001_SetScore(params) {
    return defaultApi({
      method: 'get',
      url: 'S03/S47/S47W2001_SetScore',
      params,
    });
  },
  S47W2001_Calculate(data) {
    return defaultApi({
      method: 'post',
      url: 'S03/S47/S47W2001_Calculate',
      data,
    });
  },
  S47W2001_TranToReg(data) {
    return defaultApi({
      method: 'post',
      url: 'S03/S47/S47W2001_TranToReg',
      data,
    });
  },
  S47W2001_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S03/S47/S47W2001_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },

  // =======================================================================================
};
